module.exports = __webpack_public_path__ + "static/media/azet-logo-no-text-white.6aa86cc2.png";